import { useNavigate } from "react-router-dom";
import { getAllSuppliers } from "../../reduxSaga/actions";

import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useRef, useState } from "react";
import EditRealWarehouse from "../../ui/EditRealWarehouse";
import { Snackbar } from "@material-ui/core";
import PurchaseService from "../../services/PurchaseOrder";
import { Alert } from "@material-ui/lab";
import UploadBcdFile from "../../ui/UploadBcFile";
import BDCNonConfirme from "./Table/BDCNonConfirme";
import BDCRelatedFacture from "./Table/BDCRelatedFacture";
import BDCArchived from "./Table/BDCArchived";
import withLoader from "../../components/layouts/WithLoader";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import CashRegisterService from "../../services/ProductSellBToC/CashRegisterService";

const BDCs = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const suppliers = useSelector((state) => state.staff.suppliers.Societe);
  const [oldWarehouseData, setOldWarehouseData] = useState();
  const [onEditWarehouse, setOnEditWarehouse] = useState(false);
  const animatedComponents = makeAnimated();
  const [userRole, setUserRole] = useState("");
  const [supplierId, setSupplierId] = useState(0);
  const [supplierSelectPlaceHolder, setSupplierSelectPlaceHolder] =
    useState("Tous");
  const [allSuppliers, setAllSuppliers] = useState([
    { value: 0, label: "Tous" },
  ]);
  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [supplierSelectedOption, setSupplierSelectedOption] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inConfirmedBdc, setInConfirmedBdc] = useState([]);
  const [archivedBdc, setArchivedBdc] = useState([]);
  const [bdcRelatedToInvoice, setBdcRelatedToInvoice] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [onUploadFile, setOnUploadFile] = useState(false);
  const [bdcUploadInformation, setBdcUploadInformation] = useState({
    reference: "any",
    state: 0,
    inConfirmedBdc: inConfirmedBdc,
  });
  const [chargedBDCInfo, setChargedBDCInfo] = useState(true);
  const [chargedBDCArchivedInfo, setChargedBDCArchivedInfo] = useState(false);
  // incrémenté à chaque nouveau filtrage pour remonter les tableaux
  // (react-bootstrap-table + filterFactory garde sinon ses anciennes données)
  const [tablesVersion, setTablesVersion] = useState(0);
  const filterRequestId = useRef(0);
  const [magasinSelectedOption, setMagasinSelectedOption] = useState(null);
  const [magasinId, setMagasinId] = useState(0);
  const [magasinSelectPlaceHolder, setMagasinSelectPlaceHolder] = useState("");
  const [allMagasin, setAllMagasin] = useState([]);

  useEffect(() => {
    CashRegisterService.getAllShop(getCurrentUserId())
      .then((response) => {
        if (response.data.success) {
          setAllMagasin(
            response.data.success.map((element) => ({
              value: element.id,
              label: element.name,
            }))
          );
        } else {
          console.log("error in getAllShop", response.data);
        }
      })
      .catch((e) => {
        console.log("error in getAllShop", e);
      });
  }, []);

  useEffect(() => {
    if (localStorage.getItem("status") === null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }

    dispatch(getAllSuppliers());

    startLoading();
    let pendingRequests = 2;
    const requestDone = () => {
      pendingRequests -= 1;
      if (pendingRequests === 0) stopLoading();
    };
    PurchaseService.getBDCOfLastMonth(0)
      .then((response) => {
        if (response.data.success) {
          const data = response.data.success;
          setInConfirmedBdc(data.filter((element) => element.state === 0));
          setBdcRelatedToInvoice(data.filter((element) => element.state === 1));
          setChargedBDCInfo(true);
        }
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :" + e);
      })
      .finally(requestDone);

    PurchaseService.getBDCOfLastMonth(1)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          setArchivedBdc(response.data.success);
          setChargedBDCArchivedInfo(true);
        }
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :" + e);
      })
      .finally(requestDone);
  }, []);

  useEffect(() => {
    suppliers &&
      suppliers.forEach((element) => {
        if (element?.id === undefined) return;
        setAllSuppliers((oldArray) =>
          oldArray.some((s) => s.value === element.id)
            ? oldArray
            : [...oldArray, { value: element.id, label: element.title }]
        );
      });
  }, [suppliers]);

  useEffect(() => {
    if (dateBegin === ":59") {
      setDateBegin("any");
    }
    if (dateEnd === ":59") {
      setDateEnd("any");
    }
  }, [dateBegin, dateEnd]);

  const onAddBdcHandler = () => {
    navigate(`/addBDC`);
  };
  const onAddBdcHandlerMagasin = () => {
    navigate(`/addMagasin`);
  };

  const onChangeSelectedMagasin = (selectedOptionn) => {
    setSelectedOption();
    setMagasinId(selectedOptionn.value);
    setMagasinSelectedOption(selectedOptionn.label);
    setMagasinSelectPlaceHolder(selectedOptionn.label);
  };

  const onChangeSelectedSupplier = (selectedOptionn) => {
    setSelectedOption();
    setSupplierId(selectedOptionn.value);
    setSupplierSelectPlaceHolder(selectedOptionn.label);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeDateBegin = (event) => {
    const selectedValue = event.target.value;
    const updatedValue = !selectedValue
      ? "any" // date effacée : pas de filtre sur la date
      : selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00"
      : selectedValue + "T00:00:00"; // début de journée
    setDateBegin(updatedValue);
  };

  const onChangeDateEnd = (event) => {
    const selectedValue = event.target.value;
    const updatedValue = !selectedValue
      ? "any" // date effacée : pas de filtre sur la date
      : selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":59"
      : selectedValue + "T23:59:59"; // fin de journée
    setDateEnd(updatedValue);
  };

  const onGetBdcByFiltersHandler = () => {
    const requestId = ++filterRequestId.current;
    // -1 : archivés, 0 : non confirmés, 1 : liés à une facture
    const states = [-1, 0, 1];

    startLoading();
    Promise.all(
      states.map((state) =>
        PurchaseService.getBDCByFilters(
          supplierId,
          state,
          dateBegin,
          dateEnd,
          magasinId
        )
      )
    )
      .then((responses) => {
        // ignorer la réponse d'un ancien clic sur "Valider le choix"
        if (requestId !== filterRequestId.current) return;

        // L'API renvoie { ttc, success, htc } : "success" n'est PAS la première clé,
        // donc on lit directement data.success au lieu de Object.keys(...)[0]
        const extract = (res) =>
          Array.isArray(res.data?.success) ? res.data.success : [];
        const [archived, nonConfirmed, related] = responses.map(extract);

        setArchivedBdc(archived);
        setInConfirmedBdc(nonConfirmed);
        setBdcRelatedToInvoice(related);
        setChargedBDCArchivedInfo(true);
        setChargedBDCInfo(true);
        setTablesVersion((v) => v + 1); // un seul remontage des tableaux
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :" + e);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const fmt = (v) => parseFloat(Number(v).toFixed(3));
  const caHT = inConfirmedBdc.reduce(
    (sum, r) => sum + (Number(r.buyingPrice) || 0),
    0
  );
  const caTT = inConfirmedBdc.reduce(
    (sum, r) => sum + (Number(r.ttPrice) || 0),
    0
  );
  const totalTVA = caTT - caHT;
  const nbAttente = inConfirmedBdc.filter((r) => r.stateLivraison === 0).length;
  const nbEnCours = inConfirmedBdc.filter((r) => r.stateLivraison === 1).length;
  const nbTermine = inConfirmedBdc.filter((r) => r.stateLivraison === 2).length;

  const labelStyle = {
    fontSize: "0.8rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    color: "#6c757d",
  };
  const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };
  const canCreate =
    userRole.includes("ADMIN") || userRole.includes("PURCHASING_MANAGER");

  const kpis = [
    {
      label: "CA H.T",
      value: fmt(caHT),
      hint: "Somme P.A.HT",
      icon: "fas fa-dollar-sign",
    },
    {
      label: "CA T.T",
      value: fmt(caTT),
      hint: "Somme P.A.TT",
      icon: "fas fa-dollar-sign",
    },
    {
      label: "Total TVA",
      value: fmt(totalTVA),
      hint: "P.A.TT - P.A.HT",
      icon: "fas fa-hand-holding-usd",
    },
  ];

  const newButton = (label, onClick) => (
    <button
      className="btn btn-dark mr-2 mb-1 d-inline-flex align-items-center"
      style={{ borderRadius: 8, padding: "8px 18px 8px 10px", fontWeight: 500 }}
      onClick={onClick}
    >
      <span
        className="d-inline-flex align-items-center justify-content-center mr-2"
        style={{
          width: 26,
          height: 26,
          borderRadius: 6,
          backgroundColor: "rgba(255,255,255,.18)",
        }}
      >
        <i className="fas fa-plus" style={{ fontSize: 12 }} />
      </span>
      {label}
    </button>
  );

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-file-signature mr-2"></i>Les bons de
                commande d'achat
              </h4>
              <small className="text-muted">
                Par défaut, les bons de commande ajoutés durant le dernier mois
              </small>
            </div>
            {canCreate && (
              <div className="mt-2 mt-sm-0">
                {newButton("Nouveau bon de commande", onAddBdcHandler)}
                {/* {newButton("Nouveau BDC magasin", onAddBdcHandlerMagasin)} */}
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="card card-outline card-dark mt-3" style={cardStyle}>
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-filter mr-2"></i>Filtres
              </h3>
            </div>
            <div className="card-body">
              <div className="row">
                {/* <div className="col-md-3">
                  <div className="form-group">
                    <label style={labelStyle}>Magasin</label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={magasinSelectedOption}
                      onChange={onChangeSelectedMagasin}
                      options={allMagasin}
                      placeholder={magasinSelectPlaceHolder}
                    />
                  </div>
                </div> */}
                <div className="col-md-4">
                  <div className="form-group">
                    <label style={labelStyle}>Fournisseur</label>
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      defaultValue={supplierSelectedOption}
                      onChange={onChangeSelectedSupplier}
                      options={allSuppliers}
                      placeholder={supplierSelectPlaceHolder}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="date-begin" style={labelStyle}>
                      Date début
                    </label>
                    <input
                      id="date-begin"
                      type="date"
                      className="form-control"
                      onChange={onChangeDateBegin}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="date-end" style={labelStyle}>
                      Date fin
                    </label>
                    <input
                      id="date-end"
                      type="date"
                      className="form-control"
                      onChange={onChangeDateEnd}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer text-right">
              <button className="btn btn-dark" onClick={onGetBdcByFiltersHandler}>
                <i className="fas fa-search mr-1"></i>
                Valider le choix
              </button>
            </div>
          </div>

          {chargedBDCInfo && inConfirmedBdc.length > 0 && (
            <>
              <div className="row">
                {kpis.map((k) => (
                  <div className="col-md-3 col-sm-6" key={k.label}>
                    <div
                      className="d-flex align-items-center p-3 mb-3 bg-white"
                      style={{ ...cardStyle, borderLeft: "4px solid #343a40" }}
                    >
                      <span
                        className="d-flex align-items-center justify-content-center bg-dark text-white mr-3"
                        style={{ width: 44, height: 44, borderRadius: 8 }}
                      >
                        <i className={k.icon}></i>
                      </span>
                      <div>
                        <small
                          className="text-muted text-uppercase d-block"
                          style={{ fontWeight: 600, letterSpacing: "0.03em" }}
                        >
                          {k.label}
                        </small>
                        <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                          {k.value}
                        </span>
                        <small className="text-muted d-block">{k.hint}</small>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-md-3 col-sm-6">
                  <div
                    className="d-flex align-items-center p-3 mb-3 bg-white"
                    style={{ ...cardStyle, borderLeft: "4px solid #343a40" }}
                  >
                    <span
                      className="d-flex align-items-center justify-content-center bg-dark text-white mr-3"
                      style={{ width: 44, height: 44, borderRadius: 8 }}
                    >
                      <i className="fas fa-chart-pie"></i>
                    </span>
                    <div>
                      <small
                        className="text-muted text-uppercase d-block"
                        style={{ fontWeight: 600, letterSpacing: "0.03em" }}
                      >
                        État BDC
                      </small>
                      <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                        {inConfirmedBdc.length}
                      </span>
                      <div>
                        <span className="badge badge-warning mr-1">
                          {nbAttente} En attente
                        </span>
                        <span className="badge badge-primary mr-1">
                          {nbEnCours} En cours
                        </span>
                        <span className="badge badge-success">
                          {nbTermine} Terminé
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <BDCNonConfirme
                key={`nc-${tablesVersion}`}
                listBDC={inConfirmedBdc}
              />
            </>
          )}

          {chargedBDCInfo && bdcRelatedToInvoice.length > 0 && (
            <BDCRelatedFacture
              key={`rf-${tablesVersion}`}
              listBDC={bdcRelatedToInvoice}
            />
          )}

          {chargedBDCArchivedInfo && (
            <BDCArchived key={`ar-${tablesVersion}`} listBDC={archivedBdc} />
          )}
        </div>
      </section>

      {onEditWarehouse && (
        <EditRealWarehouse
          setOnEditWarehouse={setOnEditWarehouse}
          oldWarehouseData={oldWarehouseData}
        />
      )}
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      {onUploadFile && (
        <UploadBcdFile
          setOnUploadFile={setOnUploadFile}
          setInConfirmedBdc={setInConfirmedBdc}
          setBDCRelatedToInvoice={setBdcRelatedToInvoice}
          bdcUploadInformation={bdcUploadInformation}
          setArchivedBdc={setArchivedBdc}
        />
      )}
    </div>
  );
};
export default withLoader(BDCs);
